import { render, staticRenderFns } from "./FormBasedProviderWidget.vue?vue&type=template&id=b473b8ce&"
import script from "./FormBasedProviderWidget.vue?vue&type=script&lang=js&"
export * from "./FormBasedProviderWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports